import axios from 'axios';

// API Base URL
const API_BASE_URL = 'https://www.hb-volleyball.co.kr/api';

// Axios 인스턴스 생성
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터: 모든 요청에 JWT 토큰 자동 추가
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터: 401 에러 시 로그아웃 처리
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // 토큰 만료 또는 인증 실패
      // 현재 경로가 보호된 경로인 경우에만 로그인 페이지로 리다이렉트
      const currentPath = window.location.pathname;
      const protectedPaths = ['/admin', '/member'];
      const isProtectedPath = protectedPaths.some(path => currentPath.startsWith(path));
      
      if (isProtectedPath) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      // 공개 페이지(/, /login, /register, /guest-apply 등)에서는 리다이렉트하지 않음
    }
    return Promise.reject(error);
  }
);

export default apiClient;

// API 엔드포인트
export const API_ENDPOINTS = {
  // 인증
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  ME: '/auth/me',
  
  // 회원
  MEMBERS: '/members',
  
  // 공지사항
  NOTICES: '/notices',
  
  // 게스트
  GUESTS: '/guests',
  
  // 일정
  SCHEDULES: '/schedules',
  
  // 회비
  FEES: '/fees',
  
  // 유니폼
  UNIFORMS: '/uniforms',
  
  // 대회
  COMPETITIONS: '/competitions',
  
  // 이벤트
  EVENTS: '/events',
};

